import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { theme } from "../../styles/theme";
import { Modal } from "../ui/Modal";
import { Button } from "../ui/Button";
import { Label, ErrorMessage } from "../ui/Input";
import { enhanceProjectPrompt } from "../../services/api";

const Layout = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.lg};
`;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 140px;
  padding: ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.md};
  border: ${theme.borders.base};
  font-family: inherit;
  resize: vertical;
`;

const ActionRow = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  flex-wrap: wrap;
  justify-content: flex-end;
`;

function ModifyPromptDialog({ isOpen, project, onClose }) {
  const [instructions, setInstructions] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen && project) {
      setInstructions("");
      setError("");
    }
  }, [isOpen, project]);

  if (!project) return null;

  const handleModify = async (event) => {
    event.preventDefault();
    if (!instructions.trim()) {
      setError("Please enter instructions");
      return;
    }
    setLoading(true);
    setError("");
    const combined = `${project.video_prompt || ""}\nInstructions: ${instructions.trim()}`;
    onClose?.();
    enhanceProjectPrompt(project.id, combined)
      .catch((err) => {
        // Dialog is closed; log error and optionally surface via console
        // eslint-disable-next-line no-console
        console.error("Failed to modify prompt", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal isOpen={isOpen} onClose={loading ? undefined : onClose} title="Modify prompt">
      <Layout onSubmit={handleModify}>
        <div>
          <Label htmlFor="modify-instructions">Instructions</Label>
          <TextArea
            id="modify-instructions"
            value={instructions}
            onChange={(event) => setInstructions(event.target.value)}
            disabled={loading}
            placeholder="e.g., make hair blonde and wavy, lighten background..."
          />
          {error && <ErrorMessage>{error}</ErrorMessage>}
        </div>

        <ActionRow>
          <Button type="button" variant="ghost" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Apply changes"}
          </Button>
        </ActionRow>
      </Layout>
    </Modal>
  );
}

export default ModifyPromptDialog;

